enum KeyCode {
  backspaceKeyCode = 8,
  tabKeyCode = 9,
  enterKeyCode = 13,
  shiftKeyCode = 16,
  escapeKeyCode = 27,
  spaceKeyCode = 32,
  pageUpKeyCode = 33,
  pageDownKeyCode = 34,
  leftArrowKeyCode = 37,
  upArrowKeyCode = 38,
  rightArrowKeyCode = 39,
  downArrowKeyCode = 40,
  deleteKeyCode = 46
}
/**
 *
 */
enum FinishState {
  Completed,
  Cancelled,
  Errored
}

/**
 * multi-action control constant
 */
enum MultiActionUiState {
  Valid,
  NotAllowed,
  NotKnown
}

export class UiControlConstants {
  public readonly keyCode: any;
  public readonly finishState: any;
  public readonly multiActionUiState: any;

  constructor() {
    this.keyCode = KeyCode;
    this.finishState = FinishState;
    this.multiActionUiState = MultiActionUiState;
  }
}
